import React from 'react'
import ageImg from '../assets/images/patient_age.png'
import diagImg from "../assets/images/clinical.png"

const Segment = ({ content, diagnosis, onSelected, type }) => {
    let c = content;
    let answerSelected = (event) => {
        let value = event.currentTarget.attributes['value'].value;
        let selected = event.currentTarget.attributes['isselected'].value;
        let disabled = event.currentTarget.attributes['isdisabled'].value;
        if (disabled === "true") {
            return;
        }

        if (selected == "true") {
            onSelected(c.id, { text: "" });
        } else {
            onSelected(c.id, { text: value });
        }
    }

    let isSelected = (c, o) => {
        return (c.value === o.value || c.value === o.text);
    }
    let isEnabled = (o) => {
        return o.enabled !== false;
    }

    let checkforHtml = () => {
        if(c.title != null) {
            let newText = "" + c.title;
            if(newText.includes("<b>") || newText.includes("<i>") || newText.includes("<br>")) {
                return(<span dangerouslySetInnerHTML={({__html: c.title})}></span>)
            } else {
                return(<span>{c.title}</span>)
            }
        } else {
            return(<span>{c.title}</span>)
        }
    }

    const choicesClasses =
        c.type == "segment" || (c.choices.length == 0)
            ? "segmented-options-" + c.choices.length
            : "segmented-options-vertical segmented-options-vertical-" +
            c.choices.length;

    let innerClass = (type != "radio") ? "question-content" : "";
    
    var image = null;
    if (c.title == "Age") {
        image = ageImg;
    } else if (c.title == "Clinical Situation" || c.title == "Special Situations") {
        image = diagImg;
    }

    if(c.type == "horizontal") {
        return (
            <div className={"question " + innerClass}>
                <h3 className={c.style + " selected"}>{image ? <img className="icon" style={{width:"18px", marginRight:"8px", marginLeft: "2px"}} src={image}/> : null}{checkforHtml()}</h3>
                <p dangerouslySetInnerHTML={{ __html: c.text }} />
                <div className={"segmented-options segmented-options- scrollArea"}>
                    {c.choices.map((o) => {
                        return (
                            <label onClick={answerSelected}
                                key={o.text}
                                isselected={isSelected(c, o) ? "true" : "false"}
                                isdisabled={!isEnabled(o) ? "true" : "false"}
                                value={o.text}
                                className={`
                            form-control
                            ${c.style}
                            ${isSelected(c, o) ? "selected" : ""}
                            ${isEnabled(o) ? "" : "disabled"}`
                                }>
                                    <img style={{width:"95px", marginLeft:"auto", marginRight:"auto"}} src={"../assets/" + o.img + ".png"}/>
                                    <div>{o.text}</div>
                                </label>
                        );
                    })}
                </div>
            </div>)
    } else {
        return (
            <div className={"question " + innerClass}>
                <h3 className={c.style + " selected"}>{image ? <img className="icon" style={{width:"18px", marginRight:"8px", marginLeft: "2px"}} src={image}/> : null}{checkforHtml()}</h3>
                <p>{c.text}</p>
                <div className={ " segmented-options " + choicesClasses}>
                    {c.choices.map((o) => {
                        return (
                            <label onClick={answerSelected}
                                key={o.text}
                                isselected={isSelected(c, o) ? "true" : "false"}
                                isdisabled={!isEnabled(o) ? "true" : "false"}
                                value={o.value || o.text}
                                className={`
                            form-control
                            ${c.style}
                            ${isSelected(c, o) ? "selected" : ""}
                            ${isEnabled(o) ? "" : "disabled"}`
                                } dangerouslySetInnerHTML={{ __html: o.text}}></label>
                        );
                    })}
                </div>
            </div>)
    }
};

export default Segment